import { createAsyncAction } from 'typesafe-actions'
import { Dispatch } from 'redux'
import api from 'api/graphql/graphql'
import { PersonIDInput, PsqResults } from 'types/global'
import { PersonPSQInput } from 'types/api/types'

export const PSQ_REQUESTED = 'psq/PSQ_REQUESTED'
export const PSQ_COMPLETED = 'psq/PSQ_COMPLETED'
export const PSQ_FAILED = 'psq/PSQ_FAILED'

export const performPsqSubmit = createAsyncAction(PSQ_REQUESTED, PSQ_COMPLETED, PSQ_FAILED)<
  void,
  PsqResults,
  Error
>()

export const submitPsq = (playerId: PersonIDInput, input: any) => (dispatch: Dispatch) => {
  dispatch(performPsqSubmit.request())
  api
    .submitPsq(playerId, input)
    .then(data => dispatch(performPsqSubmit.success(data)))
    .catch(e => {
      console.warn('Failed to submit PSQ', e && e.message)
      dispatch(performPsqSubmit.failure(e))
    })
}

export const submitPsqPublic = (input: PersonPSQInput) => (dispatch: Dispatch) => {
  dispatch(performPsqSubmit.request())
  api
    .submitPsqPublic(input)
    .then(data => dispatch(performPsqSubmit.success(data)))
    .catch(e => {
      console.warn('Failed to submit PSQ', e && e.message)
      dispatch(performPsqSubmit.failure(e))
    })
}
